var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "product-preview-video-wrapper" }, [
    _vm.is_frozen
      ? _c(
          "div",
          { staticClass: "frozen-overlay", attrs: { title: _vm.frozen_title } },
          [_c("div", [_vm._v("Deactivated")])]
        )
      : _vm._e(),
    _vm._v(" "),
    _c(
      "div",
      {
        staticClass: "product-preview product-video-container",
        attrs: { id: "product-video-container" }
      },
      [
        _c(
          "div",
          { staticClass: "product-video", attrs: { id: "product-video" } },
          [
            _vm.playable
              ? _c(
                  "div",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value:
                          _vm.videoSource === "video" && !_vm.rent_activated,
                        expression: "videoSource === 'video' && !rent_activated"
                      }
                    ],
                    staticClass: "start-to-rental",
                    style: { "background-image": "url(" + _vm.poster + ")" }
                  },
                  [
                    _c(
                      "div",
                      {
                        staticClass: "btn btn-browse btn-sm",
                        on: {
                          click: function($event) {
                            return _vm.startToRental()
                          }
                        }
                      },
                      [
                        _vm._v(
                          "\n                    Start to rental\n                    "
                        ),
                        _c("i", {
                          staticClass: "fa",
                          class: !_vm.reqRentActivate
                            ? "fa-play-circle"
                            : "fa-spinner fa-pulse"
                        })
                      ]
                    )
                  ]
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.playable
              ? _c("div", {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.rent_activated || _vm.videoSource !== "video",
                      expression: "(rent_activated || videoSource !== 'video')"
                    }
                  ],
                  ref: "theoplayer",
                  staticClass: "theoplayer-container video-js theoplayer-skin"
                })
              : _c("div", { staticClass: "theo-unable" }, [
                  _vm._v(
                    _vm._s(_vm.browserName) +
                      " play will be available soon. Please use Safari to play this content."
                  )
                ])
          ]
        )
      ]
    ),
    _vm._v(" "),
    !_vm.is_frozen &&
    _vm.has_access &&
    _vm.main_source_available &&
    !_vm.is_audio
      ? _c("div", { staticClass: "v-tabs" }, [
          _c(
            "a",
            {
              class: { active: _vm.videoSource === "preview" },
              on: {
                click: function($event) {
                  return _vm.play("preview")
                }
              }
            },
            [_vm._v("preview\n        ")]
          ),
          _c(
            "a",
            {
              class: { active: _vm.videoSource === "video" },
              on: {
                click: function($event) {
                  return _vm.play("video")
                }
              }
            },
            [_vm._v(_vm._s(_vm.is_audio ? "podcast" : "video"))]
          )
        ])
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }